import { isBefore } from 'date-fns';

const isDayBefore = (day1: Date, day2: Date) =>
  isBefore(
    new Date(day1.getFullYear(), day1.getMonth(), day1.getDate()),
    new Date(day2.getFullYear(), day2.getMonth(), day2.getDate()),
  );

export { isDayBefore };
